import { ENDPOINTS } from "Config/endpoints";
import protectedApi from "Config/protectedApi";

export const getTestimonialFn = () => {
    const response = protectedApi.get(`${ENDPOINTS.testimonial_api}`);
    return response;
}

export const getTestimonialByIdFn = (id) => {
    const response = protectedApi.get(`${ENDPOINTS.testimonial_api}?testimonial_id=${id}`);
    return response;
}

export const postTestimonialFn = (reqBody) => {
    const response = protectedApi.post(`${ENDPOINTS.testimonial_api}`, reqBody);
    return response;
}

export const patchTestimonialFn = (reqBody) => {
    const response = protectedApi.patch(`${ENDPOINTS.testimonial_api}`, reqBody);
    return response;
}

export const deleteTestimonialFn = (reqBody) => {
    const response = protectedApi.delete(`${ENDPOINTS.testimonial_api}`, { data: reqBody });
    return response;
}
